import {
  SIGN_IN_FAIL,
  SIGN_IN_REQUEST,
  SIGN_IN_SUCCESS,
  SIGN_UP_FAIL,
  SIGN_UP_REQUEST,
  SIGN_UP_SUCCESS,
  SIGN_OUT_SUCCESS
} from "./actions";
import { IReduxState, IAuthResponse } from "app/api/types";

type IState = IAuthResponse & IReduxState;

const initialState: IState = {
  token: "",
  isSignFail: false,
  isLoading: false
};

const authReducer = (
  state = initialState,
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case SIGN_IN_REQUEST:
    case SIGN_UP_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case SIGN_IN_SUCCESS:
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isSignFail: false,
        isLoading: false
      };

    case SIGN_IN_FAIL:
    case SIGN_UP_FAIL:
      return {
        ...state,
        isSignFail: true,
        isLoading: false
      };

    case SIGN_OUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default authReducer;
